import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {addLocale} from "primereact/api";
import {Calendar as PCalendar} from "primereact/calendar";
import {InputSwitch} from "primereact/inputswitch";
import axios from "axios";
import moment from "moment";

const CalendarFormComponent = (props) => {
  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const rangeRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [noteError, setNoteError] = useState(null);
  const [categoryError, setCategoryError] = useState(null);
  const [employeeError, setEmployeeError] = useState(null);
  const [rangeError, setRangeError] = useState(null);
  const [formData, setFormData] = useState({
    accepted: false,
    start_date: new Date(),
    end_date: new Date(),
    range: null
  });
  const [categories, setCategories] = useState([]);
  const [employees, setEmployees] = useState([]);

  const validate = () => ({});

  const apiCall = (method, url, data) => {
    return axios({
      method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    });
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember', 'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  useEffect(() => {
    const q = window.App.urlVars();
    const day = q.day;
    const start = q.start;
    const end = q.end;

    const base = { ...formData };

    if (entity === 'employee' && id) {
      base.employee = Number(id);
    }

    if (start && end) {
      base.start_date = moment(start, 'YYYY-MM-DD').format('YYYY-MM-DD');
      base.end_date = moment(end, 'YYYY-MM-DD').format('YYYY-MM-DD');
      base.range = [
        moment(start, 'YYYY-MM-DD').toDate(),
        moment(end, 'YYYY-MM-DD').toDate()
      ];
    } else if (day) {
      base.start_date = moment(day, 'YYYY-MM-DD').format('YYYY-MM-DD');
      base.end_date = moment(day, 'YYYY-MM-DD').format('YYYY-MM-DD');
      base.range = [
        moment(day, 'YYYY-MM-DD').toDate(),
        moment(day, 'YYYY-MM-DD').toDate()
      ];
    } else {
      const today = moment().format('YYYY-MM-DD');
      base.start_date = today;
      base.end_date = today;
      base.range = [moment(today, 'YYYY-MM-DD').toDate(), moment(today, 'YYYY-MM-DD').toDate()];
    }

    setFormData(base);

    apiCall('get', '/api/v2/hr-calendar-category')
      .then(res => setCategories(res.data?.data?.items || []))
      .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response));

    const _emloyeeQuery = { rows: 9999 };
    const emloyeeQuery = window.App.transformQueryParams(_emloyeeQuery);
    apiCall('get', '/api/v2/employee' + emloyeeQuery)
      .then(res => setEmployees(res.data?.data?.items || []))
      .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response));

    if ((!q.create && q.calendarId) || (entity === 'calendar' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/hr-calendar/' + (q.calendarId ?? id))
        .then(res => {
          const d = res.data.data;
          const s = moment(d.start_date, 'YYYY-MM-DD');
          const e = moment(d.end_date, 'YYYY-MM-DD');
          setFormData({
            ...d,
            start_date: s.format('YYYY-MM-DD'),
            end_date: e.format('YYYY-MM-DD'),
            range: [s.toDate(), e.toDate()]
          });
        })
        .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response))
        .finally(() => setLoading(false));
    }
  }, []);

  const onSubmit = () => {
    setLoading(true);
    setNoteError(null);
    setCategoryError(null);
    setEmployeeError(null);
    setRangeError(null);
    const payload = { ...formData };
    const r = rangeRef.current ?? formData.range;
    if (Array.isArray(r) && r[0]) {
      const s = moment(r[0]).format('YYYY-MM-DD');
      const e = r[1] ? moment(r[1]).format('YYYY-MM-DD') : s;
      payload.start_date = s;
      payload.end_date = e;
    }

    const q = window.App.urlVars();
    const targetId = (q.calendarId ?? id);

    const request = ((entity === 'calendar' && id) || q.calendarId)
      ? apiCall('patch', '/api/v2/hr-calendar/' + targetId, payload)
      : apiCall('post', '/api/v2/hr-calendar', payload);

    request
      .then(response => {
        window.App.toastShow('success', 'Sikeres mentés!');
        window.App.setState({ rerenderCalendar: Math.random() });
        if (props.goback === true) {
          history.push(props.backlink);
        } else if (!(entity === 'employee')) {
          history.push('/hr/calendar/update/' + (response?.data?.data?.id ?? targetId));
        }
      })
      .catch(error => {
        const serverErrors = error.response?.data?.data;
        if (serverErrors) {
          window.App.toastShow('error', t('error'), error.toString(), '');
          if (serverErrors.hr_calendar_category) setCategoryError(serverErrors.hr_calendar_category[0]);
          if (serverErrors.note) setNoteError(serverErrors.note[0]);
          if (serverErrors.employee) setEmployeeError(serverErrors.employee[0]);
          if (serverErrors.start_date) setRangeError(serverErrors.start_date[0]);
        } else {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        }
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className={"citizenship-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate" style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0}} />
      }

      <Form onSubmit={onSubmit} initialValues={formData} validate={validate}
        render={({handleSubmit}) => (
        <form onSubmit={handleSubmit}>
          <div className="p-grid">
            <div className={"p-col-12 p-lg-8"}>
              <div className="p-field p-fluid">
                <label htmlFor="range">{props.t('fieldRange')}</label>
                <PCalendar
                  id="range"
                  selectionMode="range"
                  locale="hu"
                  dateFormat="yy-mm-dd"
                  value={formData.range}
                  onChange={(e) => {
                    const val = e.value;
                    rangeRef.current = val;
                    if (Array.isArray(val) && val[0] && val[1]) {
                      setFormData({
                        ...formData,
                        range: val,
                        start_date: moment(val[0]).format('YYYY-MM-DD'),
                        end_date: moment(val[1]).format('YYYY-MM-DD')
                      });
                    } else {
                      setFormData({...formData, range: val});
                    }
                  }}
                  readOnlyInput
                  showIcon
                />
                {rangeError && <small className="p-error p-d-block">{rangeError}</small>}
              </div>
            </div>

            <div className={"p-col-12 p-lg-4"}>
              <div className="p-field p-fluid">
                <label htmlFor="employee">{props.t('employee')}</label>
                <Dropdown
                  options={window.App.sortDropdownOptions(employees, "name")}
                  id={"employee"}
                  filter
                  disabled={window.App.urlVars().employeeId}
                  optionValue={"id"}
                  optionLabel={"name"}
                  emptyMessage={t('noEmployeeYet')}
                  onChange={(e) => {
                    setFormData({ ...formData, employee: e.value });
                    if (employeeError) setEmployeeError(null);
                  }}
                  value={Number(window.App.urlVars().employeeId) || formData.employee?.id || formData.employee}
                />
                {employeeError && <small className="p-error p-d-block">{employeeError}</small>}
              </div>
            </div>

            {/* <div className={"p-col-12 p-lg-4"}>
              <div className="p-field p-fluid">
                <label htmlFor="start_date">{props.t('fieldStart')}</label>
                <div className="p-inputgroup calendar-icon-only">
                  <InputMask
                    id="start_date"
                    mask="9999-99-99"
                    placeholder={t('datePlaceholder')}value={moment(formData.start_date, 'YYYY-MM-DD').format('YYYY-MM-DD')}
                    onChange={(e) => {
                      if (e.value.indexOf("_") === -1) {
                        const v = e.value || null;
                        setFormData({
                          ...formData,
                          start_date: v ? moment(v, 'YYYY-MM-DD').format('YYYY-MM-DD') : null,
                          range: v && formData.end_date
                            ? [moment(v, 'YYYY-MM-DD').toDate(), moment(formData.end_date, 'YYYY-MM-DD').toDate()]
                            : formData.range
                        });
                      }
                    }}
                  />
                  <PCalendar
                    value={formData.start_date ? moment(formData.start_date, 'YYYY-MM-DD').toDate() : null}
                    locale="hu"
                    dateFormat="yy-mm-dd"
                    showIcon
                    onChange={(e) => {
                      const v = e.value ? moment(e.value).format('YYYY-MM-DD') : null;
                      setFormData({
                        ...formData,
                        start_date: v,
                        range: v && formData.end_date
                          ? [moment(v, 'YYYY-MM-DD').toDate(), moment(formData.end_date, 'YYYY-MM-DD').toDate()]
                          : formData.range
                      });
                    }}
                  />
                </div>
              </div>
            </div>

            <div className={"p-col-12 p-lg-4"}>
              <div className="p-field p-fluid">
                <label htmlFor="end_date">{props.t('fieldEnd')}</label>
                <div className="p-inputgroup calendar-icon-only">
                  <InputMask
                    id="end_date"
                    mask="9999-99-99"
                    placeholder={t('datePlaceholder')}value={moment(formData.end_date, 'YYYY-MM-DD').format('YYYY-MM-DD')}
                    onChange={(e) => {
                      if (e.value.indexOf("_") === -1) {
                        const v = e.value || null;
                        setFormData({
                          ...formData,
                          end_date: v ? moment(v, 'YYYY-MM-DD').format('YYYY-MM-DD') : null,
                          range: formData.start_date && v
                            ? [moment(formData.start_date, 'YYYY-MM-DD').toDate(), moment(v, 'YYYY-MM-DD').toDate()]
                            : formData.range
                        });
                      }
                    }}
                  />
                  <PCalendar
                    value={formData.end_date ? moment(formData.end_date, 'YYYY-MM-DD').toDate() : null}
                    locale="hu"
                    dateFormat="yy-mm-dd"
                    showIcon
                    onChange={(e) => {
                      const v = e.value ? moment(e.value).format('YYYY-MM-DD') : null;
                      setFormData({
                        ...formData,
                        end_date: v,
                        range: formData.start_date && v
                          ? [moment(formData.start_date, 'YYYY-MM-DD').toDate(), moment(v, 'YYYY-MM-DD').toDate()]
                          : formData.range
                      });
                    }}
                  />
                </div>
              </div>
            </div> */}

            <div className={"p-col-12 p-lg-8"}>
              <div className="p-field p-fluid">
                <label htmlFor="note">{props.t('fieldNote')}</label>
                <InputText
                  id="note"
                  className={noteError ? 'p-invalid' : ''}
                  onChange={(e) => {
                    setFormData({ ...formData, note: e.target.value });
                    if (noteError) setNoteError(null);
                  }}
                  value={formData.note || ''}
                />
                {noteError && <small className="p-error p-d-block">{noteError}</small>}
              </div>
            </div>

            <div className={"p-col-12 p-lg-4"}>
              <div className="p-field p-fluid">
                <label htmlFor="hr_calendar_category">{props.t('fieldCategory')}</label>
                <Dropdown
                  options={window.App.sortDropdownOptions(categories, "name")}
                  id={"hr_calendar_category"}
                  className={categoryError ? 'p-invalid' : ''}
                  optionValue={"id"}
                  optionLabel={"name"}
                  emptyMessage={t('noCategoryYet')}
                  onChange={(e) => {
                    setFormData({ ...formData, hr_calendar_category: e.value });
                    if (categoryError) setCategoryError(null);
                  }}
                  value={Number(window.App.urlVars().categoryId) || formData.hr_calendar_category?.id || formData.hr_calendar_category}
                />
                {categoryError && <small className="p-error p-d-block">{categoryError}</small>}
              </div>
            </div>
            <div className={"p-col-12 p-lg-8"}>
              <div className="p-field p-fluid">
                <label htmlFor="daily_limit_one">{props.t('fieldDailyLimitOne')}</label>
                <span className="p-d-block p-mt-2">
                  <InputSwitch
                    id="daily_limit_one"
                    onChange={(e) => {
                      setFormData({ ...formData, daily_limit_one: e.value });
                    }}
                    checked={!!formData.daily_limit_one}
                  />
                </span>
              </div>
            </div>
          </div>

          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6"} />
            <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>
              {entity === 'calendar' &&
                <Button type="submit" label={t('save')} icon="pi pi-save" className="p-button-success p-ml-2" />
              }
              <Button
                type="submit"
                label={t('saveAndBack')}
                onClick={() => { props = { ...props, goback: true }; }}
                icon="pi pi-arrow-left"
                className="p-button-success p-ml-2"
              />
            </div>
          </div>
        </form>
      )}/>
    </div>
  );
};

export default withTranslation('common')(CalendarFormComponent);
